import { styled, Button } from '@mui/material';


export const LogoButton = styled(Button)`
    
  :hover {
    cursor: pointer;
    background-color: transparent;  
  }
`;